<template>
  <div v-if="usps" class="bg-[#262626] text-white">
    <div
      class="h-9 w-full flex items-center"
      v-bind="$attrs"
      :class="isCheckoutPage ? 'page-container--small' : 'page-container'">
      <Usps class="mr-4" color="transparent" />
      <div class="flex gap-4 ml-auto items-center">
        <LanguageMenuTopBar :class="isCheckoutPage ? 'ml-8' : ''" @click="close" />
        <CurrencyMenu @click="close" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import brandconfig from "@/brandconfig";
import { CurrencyMenu, LanguageMenuTopBar } from "./menu";
import { useRoute } from "vue-router";
import Usps from "@/pages/event/Usps.vue";

defineOptions({
  inheritAttrs: false,
});

const route = useRoute();
const usps = ref(brandconfig?.usps);
const isCheckoutPage = computed(() => route.path === "/checkout");
</script>
